import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, IndianRupee } from 'lucide-react';

const packages = [
  { id: 'basic', name: 'Basic Reading', duration: 30, price: 1500 },
  { id: 'standard', name: 'Standard Reading', duration: 60, price: 2500 },
  { id: 'marriage', name: 'Marriage Consultation', duration: 45, price: 2000 },
  { id: 'career', name: 'Career & Business', duration: 45, price: 2000 },
  { id: 'dasha', name: 'Dasha & Remedies', duration: 60, price: 3000 }
];

const AstrologyServicesPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] pt-24 px-6 md:px-12 lg:px-24 pb-16">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-5xl font-serif text-[#F5F2EB] text-center mb-6">Astrology Services</h1>
        <p className="text-[#A3A3A3] text-center mb-12 max-w-2xl mx-auto">
          Choose from our comprehensive astrology packages tailored to your needs
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {packages.map((pkg) => (
            <div key={pkg.id} className="bg-[#1A1A1A] border border-[#C9A84C]/15 p-6 hover:border-[#C9A84C]/30 transition-all">
              <h3 className="text-2xl font-serif text-[#F5F2EB] mb-4">{pkg.name}</h3>
              <div className="flex items-center gap-2 text-[#A3A3A3] mb-2">
                <Clock className="w-5 h-5" />
                <span>{pkg.duration} minutes</span>
              </div>
              <div className="flex items-center gap-2 text-[#C9A84C] text-2xl font-bold mb-6">
                <IndianRupee className="w-6 h-6" />
                <span>{pkg.price}</span>
              </div>
              <Link
                to="/booking"
                state={{ packageType: pkg.id, serviceType: 'astrology' }}
                className="block w-full bg-[#C9A84C] text-[#0A0A0A] text-center font-medium px-6 py-3 hover:bg-[#E5C870] transition-colors uppercase tracking-wider text-sm"
              >
                Book Now
              </Link>
            </div>
          ))}

          <div className="bg-gradient-to-br from-[#C9A84C]/10 to-[#1A1A1A] border border-[#C9A84C]/30 p-6">
            <h3 className="text-2xl font-serif text-[#C9A84C] mb-4">Pay Per Minute</h3>
            <p className="text-[#A3A3A3] mb-4">Flexible consultation at your own pace</p>
            <div className="flex items-center gap-2 text-[#C9A84C] text-2xl font-bold mb-6">
              <IndianRupee className="w-6 h-6" />
              <span>60/min</span>
            </div>
            <Link
              to="/booking"
              state={{ packageType: 'per_minute', serviceType: 'astrology' }}
              className="block w-full bg-[#C9A84C] text-[#0A0A0A] text-center font-medium px-6 py-3 hover:bg-[#E5C870] transition-colors uppercase tracking-wider text-sm"
            >
              Book Now
            </Link>
          </div>
        </div>

        <div className="mt-12 bg-[#C9A84C]/10 border border-[#C9A84C]/30 p-6 text-center">
          <p className="text-[#C9A84C] font-medium">✨ First 10 Minutes FREE for New Clients!</p>
        </div>
      </div>
    </div>
  );
};

export default AstrologyServicesPage;
